import Vue from 'vue';
import VueRouter from 'vue-router';

import PostalCheckComponent from './components/postal-check-component.vue';
import QuestionsComponent from './components/questions-component.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/tool',
        component: PostalCheckComponent
    },
    {
        path: '/tool/:id',
        component: QuestionsComponent
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior () {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    x: 0,
                    y: 0
                })
            }, 100);
        });
    }
});

export default router;
